
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errori9Edg0gghXES6Im9jgtQRuRuDxmZRKhNjxjv_sKe1sIMeta } from "/opt/build/repo/website/core/pages/error.vue?macro=true";
import { default as indexkF3ypU9o2JGmluTaAebnaUa5RjEfGk_45h_45xpT636YLA4Meta } from "/opt/build/repo/website/investor-relations/pages/index.vue?macro=true";
import { default as indexLku59HkVGXyoh4X_5up_ZuLgs0rpEgXgUohoH5_45d1UIMeta } from "/opt/build/repo/website/investor-relations/pages/events/index.vue?macro=true";
import { default as _91slug_93LQAMIsmvcWR3e_KnxLhTXGFevLJAGIC1E_451EnhPdGTEMeta } from "/opt/build/repo/website/investor-relations/pages/events/[slug].vue?macro=true";
import { default as indexRaRnR2GTAJOeu9RM2mncue7SH2CWhYTARPxmcelzFGcMeta } from "/opt/build/repo/website/investor-relations/pages/financials/index.vue?macro=true";
import { default as indexMvFukhmPSIDlvhDOJqp_uE7ube7GHD57UgksqLZNqMUMeta } from "/opt/build/repo/website/investor-relations/pages/governance/index.vue?macro=true";
import { default as _91slug_93XPqq4Xg61aOfaUIY4Rtz5PlRET1Vm9ZwGZaoqUkgBPgMeta } from "/opt/build/repo/website/investor-relations/pages/financials/[slug].vue?macro=true";
import { default as indexmnRSTxVxvI8KikeQcxc2nupULu1SXwXKfcGg_45f7IjSgMeta } from "/opt/build/repo/website/investor-relations/pages/general-meetings/index.vue?macro=true";
import { default as trading_45updatestbaYdHbmYgp6reNhHmVuZ7Jg3t9_IdekB5aHPJO3t0wMeta } from "/opt/build/repo/website/investor-relations/pages/financials/trading-updates.vue?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "error___en",
    path: "/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_AU",
    path: "/en_AU/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pt_BR",
    path: "/pt_BR/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___zh_CN",
    path: "/zh_CN/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___cs_CZ",
    path: "/cs_CZ/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___da_DK",
    path: "/da_DK/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___de_DE",
    path: "/de_DE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___es_ES",
    path: "/es_ES/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___fr_FR",
    path: "/fr_FR/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___it_IT",
    path: "/it_IT/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___ja_JP",
    path: "/ja_JP/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___es_MX",
    path: "/es_MX/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___nl_NL",
    path: "/nl_NL/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___no_NO",
    path: "/no_NO/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pl_PL",
    path: "/pl_PL/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pt_PT",
    path: "/pt_PT/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___sv_SE",
    path: "/sv_SE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_AE",
    path: "/en_AE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_SG",
    path: "/en_SG/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_GB",
    path: "/en_GB/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/opt/build/repo/website/investor-relations/pages/index.vue")
  },
  {
    name: "events___en",
    path: "/events",
    component: () => import("/opt/build/repo/website/investor-relations/pages/events/index.vue")
  },
  {
    name: "events-slug___en",
    path: "/events/:slug()",
    component: () => import("/opt/build/repo/website/investor-relations/pages/events/[slug].vue")
  },
  {
    name: "financials___en",
    path: "/financials",
    component: () => import("/opt/build/repo/website/investor-relations/pages/financials/index.vue")
  },
  {
    name: "governance___en",
    path: "/governance",
    component: () => import("/opt/build/repo/website/investor-relations/pages/governance/index.vue")
  },
  {
    name: "financials-slug___en",
    path: "/financials/:slug()",
    component: () => import("/opt/build/repo/website/investor-relations/pages/financials/[slug].vue")
  },
  {
    name: "general-meetings___en",
    path: "/general-meetings",
    component: () => import("/opt/build/repo/website/investor-relations/pages/general-meetings/index.vue")
  },
  {
    name: "financials-trading-updates___en",
    path: "/financials/trading-updates",
    component: () => import("/opt/build/repo/website/investor-relations/pages/financials/trading-updates.vue")
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_AU/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pt_BR/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/zh_CN/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/cs_CZ/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/da_DK/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/de_DE/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/es_ES/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/fr_FR/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/it_IT/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/ja_JP/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/es_MX/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl_NL/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/no_NO/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pl_PL/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pt_PT/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/sv_SE/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_AE/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_SG/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_GB/events/agm-20254",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_AU/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pt_BR/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/zh_CN/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/cs_CZ/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/da_DK/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/de_DE/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/es_ES/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/fr_FR/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/it_IT/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/ja_JP/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/es_MX/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl_NL/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/no_NO/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pl_PL/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pt_PT/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/sv_SE/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_AE/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_SG/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_GB/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  }
]